import React from "react";
import InnerBanner from "../component/Innerbanner";
import { Row, Col } from "antd";
import WhyChoose from '../component/Whychooise';
import Post from '../component/Postmention';
import Faqs from '../component/Faqs';
import Service from '../component/Service';
import { CheckCircleOutlined } from "@ant-design/icons";
import Img from "../assets/about-banner.png";
import img1 from '../assets/icon/iconbox.png';

function AboutUs() {
  return (
    <div>
      {/* Top Banner */}
      <InnerBanner name="About Company" title="Home . About us" />

      {/* About Section */}
      <div className="container mx-auto about-section py-8 md:py-12 lg:py-16 px-4 md:px-6 lg:px-8">
        <Row gutter={[24, 32]} align="middle">
          {/* Image Column */}
          <Col xs={24} md={12} lg={12}>
            <div className="main-second-banner">
              <img
                src={Img}
                alt="About Us"
                className="w-full rounded-2xl object-cover shadow-lg"
              />
            </div>
          </Col>

          {/* Content Column */}
          <Col xs={24} md={12} lg={12}>
            <div className="about-content">
              <h5 className="text-gray-500 mb-3 md:mb-4 text-xl md:text-2xl lg:text-3xl font-custom">
                About Us
              </h5>
              <h2 className="text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-bold mb-4 md:mb-6 font-custom leading-tight md:leading-snug">
                Printing Your Imagination, <br className="hidden sm:block" />
                <span className="text-[#6cc5bf]">Stitch By Stitch</span>
              </h2>
              <p className="text-gray-600 mb-6 md:mb-8 text-sm md:text-base lg:text-[16px] font-custom leading-relaxed">
                At <strong>Initial Global Trade</strong>, we turn your creative
                ideas into high-quality custom apparel that makes a statement.
                Founded in California, we specialize in custom T-shirt printing
                and personalized merchandise for individuals, businesses, and
                organizations who want to stand out.
              </p>

              {/* Feature Boxes */}
              <Row gutter={[12, 12]} className="mb-6 md:mb-8">
                <Col xs={24} sm={12}>
                  <div className="p-3 md:p-4 bg-gray-100 rounded-xl flex items-center gap-2 md:gap-3 hover:bg-gray-200 transition-colors duration-300">
                    <span className="flex-shrink-0">
                      <img src={img1} alt="box icon" className="w-6 h-6 md:w-8 md:h-8" />
                    </span>
                    <strong className="font-custom text-sm md:text-base">
                      Turning Ideas Into Wearable Art
                    </strong>
                  </div>
                </Col>
                <Col xs={24} sm={12}>
                  <div className="p-3 md:p-4 bg-gray-100 rounded-xl flex items-center gap-2 md:gap-3 hover:bg-gray-200 transition-colors duration-300">
                    <span className="flex-shrink-0">
                      <img src={img1} alt="design icon" className="w-6 h-6 md:w-8 md:h-8" />
                    </span>
                    <strong className="font-custom text-sm md:text-base">
                      Designed for Everyone
                    </strong>
                  </div>
                </Col>
              </Row>

              {/* Checklist */}
              <ul className="list-none space-y-3 md:space-y-4 text-gray-700">
                <li className="font-custom flex items-start gap-2 md:gap-3 text-sm md:text-base">
                  <CheckCircleOutlined className="text-[#6cc5bf] text-lg md:text-xl flex-shrink-0 mt-1" />
                  <span>Transform your vision into high-quality, custom-printed T-shirts.</span>
                </li>
                <li className="font-custom flex items-start gap-2 md:gap-3 text-sm md:text-base">
                  <CheckCircleOutlined className="text-[#6cc5bf] text-lg md:text-xl flex-shrink-0 mt-1" />
                  <span>Choose from premium fabrics and vibrant print options.</span>
                </li>
                <li className="font-custom flex items-start gap-2 md:gap-3 text-sm md:text-base">
                  <CheckCircleOutlined className="text-[#6cc5bf] text-lg md:text-xl flex-shrink-0 mt-1" />
                  <span>From single designs to bulk corporate orders — we've got you covered.</span>
                </li>
                <li className="font-custom flex items-start gap-2 md:gap-3 text-sm md:text-base">
                  <CheckCircleOutlined className="text-[#6cc5bf] text-lg md:text-xl flex-shrink-0 mt-1" />
                  <span>We combine creativity, craftsmanship, and technology.</span>
                </li>
              </ul>
            </div>
          </Col>
        </Row>
      </div>

      {/* Other Sections */}
      <WhyChoose />
      <Service />
      <Faqs />
      <Post />
    </div>
  );
}

export default AboutUs;